module.exports = __webpack_public_path__ + "img/template@2x(1).c71f96f3.png";